import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import {Provider} from 'react-redux'
import store from './store'
// import store,{Persistor} from './store'
// import { PersistGate } from 'redux-persist/integration/react';
import {positions,transitions,Provider as AlertProvider} from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

const options = {
  timeout:5000,
  position:positions.BOTTOM_CENTER,
  transition: transitions.SCALE
} 

ReactDOM.render(
  <Provider store={store}>
<AlertProvider template= { AlertTemplate} {...options}>
{/* <PersistGate loading={null} persistor={Persistor}> */}
    <App />
    {/* </PersistGate> */}
    </AlertProvider>
  </Provider>,
  document.getElementById('root')
);


